export const pageLayouts = {
  portrait: 'portrait',
  landscape: 'landscape'
};

export const pageSizes = {
  '4A0': { x: 4767.87, y: 6740.79 },
  '2A0': { x: 3370.39, y: 4767.87 },
  A0: { x: 2383.94, y: 3370.39 },
  A1: { x: 1683.78, y: 2383.94 },
  A2: { x: 1190.55, y: 1683.78 },
  A3: { x: 841.89, y: 1190.55 },
  A4: { x: 595.28, y: 841.89 },
  A5: { x: 419.53, y: 595.28 },
  A6: { x: 297.64, y: 419.53 },
  A7: { x: 209.76, y: 297.64 },
  A8: { x: 147.40, y: 209.76 },
  A9: { x: 104.88, y: 147.40 },
  A10: { x: 73.70, y: 104.88 },
  B0: { x: 2834.65, y: 4008.19 },
  B1: { x: 2004.09, y: 2834.65 },
  B2: { x: 1417.32, y: 2004.09 },
  B3: { x: 1000.63, y: 1417.32 },
  B4: { x: 708.66, y: 1000.63 },
  B5: { x: 498.90, y: 708.66 },
  B6: { x: 354.33, y: 498.90 },
  B7: { x: 249.45, y: 354.33 },
  B8: { x: 175.75, y: 249.45 },
  B9: { x: 124.72, y: 175.75 },
  B10: { x: 87.87, y: 124.72 },
  C0: { x: 2599.37, y: 3676.54 },
  C1: { x: 1836.85, y: 2599.37 },
  C2: { x: 1298.27, y: 1836.85 },
  C3: { x: 918.43, y: 1298.27 },
  C4: { x: 649.13, y: 918.43 },
  C5: { x: 459.21, y: 649.13 },
  C6: { x: 323.15, y: 459.21 },
  C7: { x: 229.61, y: 323.15 },
  C8: { x: 161.57, y: 229.61 },
  C9: { x: 113.39, y: 161.57 },
  C10: { x: 79.37, y: 113.39 },
  RA0: { x: 2437.80, y: 3458.27 },
  RA1: { x: 1729.13, y: 2437.80 },
  RA2: { x: 1218.90, y: 1729.13 },
  RA3: { x: 864.57, y: 1218.90 },
  RA4: { x: 609.45, y: 864.57 },
  SRA0: { x: 2551.18, y: 3628.35 },
  SRA1: { x: 1814.17, y: 2551.18 },
  SRA2: { x: 1275.59, y: 1814.17 },
  SRA3: { x: 907.09, y: 1275.59 },
  SRA4: { x: 637.80, y: 907.09 },
  EXECUTIVE: { x: 521.86, y: 756.00 },
  FOLIO: { x: 612.00, y: 936.00 },
  LEGAL: { x: 612.00, y: 1008.00 },
  LETTER: { x: 612.00, y: 792.00 },
  TABLOID: { x: 792.00, y: 1224.00 }
};



// WEBPACK FOOTER //
// ./src/constants/file.js